import script from "./EmailTemplatesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailTemplatesPage.vue?vue&type=script&setup=true&lang=ts"

import "./EmailTemplatesPage.vue?vue&type=style&index=0&id=d077e8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d077e8bc"]])

export default __exports__